export const name = "WNRS x Valentino"
export const menu = "Valentino"
export const crossover = "Valentino"
export const suggestedPlayer = "2+ players"
export const color = {
    primary: {
        main:  '#4e1214',
        contrastText: '#ffffff',
    },
    secondary: {
        main:  '#4e1214',
    }
}
export const levels = ['Valentino']
export const isExpansion = false

export const backDesc = [
    "See yourself in\n someone else"
]

export const instruction = [
    "When we show up as our authentic selves we empower others to do the same, but sometimes we need a little help opening up.",
    "This expansion pack is an invitation to deeply connect with others and with yourself. To play, both players ask each other questions; you may even reveal parts of yourself that you never met before.",
    "Ready?",
]

export const level1 = [ // 25 / 25 cards
    "What have you witnessed\n recently that has given\n you hope for humanity\n in any big or small way?",
    "What limiting belief is holding\n you back the most right now?",
    "What have you overcome this\n year that you weren't sure\n you could?",
    "When was the last time\n you felt truly understood\n by somebody? Who was it?\n What did they understand?",
    "What has this year taught\n you about yourself?\n Good and bad.",
    "Asking for help is a strength\n not a weakness. What do\n you need help with?",
    "What has your negative\n self-talk sounded like\n recently? Replace it\n with an affirmation.",
    "Who in your life can you\n have more empathy towards?\n What's getting in the\n way of that?",
    // "Who in your life\n can you show more\n empathy towards?", // Duplicate?
    "What are you judging\n yourself too harshly\n for? How can you show\n more empathy towards\n yourself?",
    "What was the last lie\n you told yourself?",
    "What are you working\n through that others\n don't see?",
    "Is there someone in your\n life you feel misunderstood\n by? What do you wish they\n would understand?",
    "What are you overthinking\n right now? Or who?",
    "How have you neglected\n yourself recently? What's\n one thing you can do to make\n it up to yourself this week,\n big or small?",
    "What \"failure\" taught\n you the most this year?\n What did it teach you?",
    "What are you holding onto that are hurting you the most? What's one small step you can take towards letting it go?",
    "Who deserves more of your time? How can you show up for them?",
    "What are you still\n trying to understand\n about yourself?",
    "What is the hardest thing for you to understand about yourself?",
    "What do you give in too much energy to? What is that at the expense of?",

    "Wild Card What would you tell\n yourself one year ago\n today? Write it out.",
    "Wild Card Write down one thing you\n want to forgive yourself for.\n Find the lesson and let it go.",
    "Wild Card Who in your life deserves the biggest thank you? Let them know now.", // ?
    "Wild Card Both players write down a\n compliment to one another.\n Fold and exchange. Open\n only when you two\n have parted.",
    "Reminder Have more empathy\n (For yourself too)",
]